import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

import { InviteFormFields } from '../types';

const peoPayrollProviderValidationSchema = yup.object({
  email: emailValidationSchema.required('Email field is required'),
  isRevenueShareEnabled: yup.boolean().required(),
});

export const inviteFormValidationSchema = yup.object({
  [InviteFormFields.peoPayrollProviders]: yup
    .array()
    .of(peoPayrollProviderValidationSchema)
    .nullable()
    .min(1, 'Field must have at least 1 item')
    .required('Required'),
});
